const RecapRow = ({ title, value }) => (
    <div className="mb-8 mt-8">
        <div className="font-medium text-2xl whitespace-nowrap mb-1">{title}</div>
        <div className="font-normal text-xl text-green-500">{value}</div>
    </div>
);

export default RecapRow;
